/*
  Action Types
*/
export const PLATFORM_OPTIONS = 'PLATFORM_OPTIONS';

/*
  Action Creators
*/
